export const API_BASE_URL = 'http://logging.idynamics.ch/public/api/auth';